export default __webpack_public_path__ + "static/media/defaultProfile.e62a0d99.jpg";